import { CashBalanceAnalysis } from "store/apis/financialMetrics";
import {
  BarForecastMeta,
  ForecastLegend,
  GenericBarChartData,
  Legend,
  LegendDot,
  buildForecastMetaByDate,
} from "../ChartComponents";
import { BarChart } from "./CashFlowChart";
import {
  CASH_BALANCE_CONFIG,
  CASH_BALANCE_LINE_COLOR,
  INFLOW_COLOR,
  OUTFLOW_COLOR,
} from "./cashBalanceChartConstants";

export { CASH_BALANCE_CONFIG };

const transformCashBalanceData = (
  data: CashBalanceAnalysis
): GenericBarChartData[] =>
  data.monthly_breakdown.map((item) => ({
    date: item.month,
    bar1: -Math.abs(item.outflow),
    bar2: item.inflow,
    lineValue: item.cash_balance,
  }));

const getCashBalanceForecastFields = (
  item: CashBalanceAnalysis["monthly_breakdown"][number]
): BarForecastMeta => ({
  isForecast: item.is_forecast,
  hasOverlapActual: item.has_overlap_actual,
  actualBar1:
    item.actual_outflow != null ? -Math.abs(item.actual_outflow) : undefined,
  actualBar2: item.actual_inflow ?? undefined,
  actualLineValue: item.actual_cash_balance ?? undefined,
});

export const CashBalanceChart = ({ data }: { data: CashBalanceAnalysis }) => {
  const chartData = transformCashBalanceData(data);
  const { forecastMetaByDate, hasForecastData } = buildForecastMetaByDate(
    data.monthly_breakdown,
    (item) => item.month,
    getCashBalanceForecastFields
  );

  return (
    <>
      <div className="t-flex t-gap-4 t-items-center t-mb-4">
        <Legend dot={<LegendDot color={OUTFLOW_COLOR} />} lable="Outflow" />
        <Legend dot={<LegendDot color={INFLOW_COLOR} />} lable="Inflow" />
        <Legend
          dot={<LegendDot color={CASH_BALANCE_LINE_COLOR} />}
          lable="Net change"
        />
        <ForecastLegend show={hasForecastData} />
      </div>
      <div className="t-h-48 t-w-full">
        <BarChart
          data={chartData}
          config={CASH_BALANCE_CONFIG}
          showLeftAxis
          showAllMonths
          forecastMetaByDate={forecastMetaByDate}
        />
      </div>
    </>
  );
};
